/**
 * Rozstawy osi (kod W, {{versionWheelbase}}) dla Iveco Tourist Line -
 * wyznaczane z fizycznego rozstawu osi [mm] i długości pojazdu [mm], obu
 * pochodzących z opcji zamówienia (patrz wheelbase-utils.ts -
 * getVersionWheelbase/resolveWheelbaseFormValues po sposób użycia).
 *
 * Klucz: rozstaw osi [mm] -> długość [mm] -> kod W. Sam rozstaw osi nie
 * wystarcza jako klucz - ten sam rozstaw (np. 4750mm) może występować z
 * różnymi długościami, a więc odpowiadać różnym wariantom W01-W12.
 *
 * @module iveco-wheelbases
 */

/** Rozstaw osi [mm] -> długość [mm] -> kod W */
export type WheelbaseTable = Record<string, Record<string, string>>;

export const IVECO_WHEELBASES: WheelbaseTable = {
  "4750": {
    "8398": "W01",
    "8400": "W01",
    "7990": "W04",
  },
  "5100": {
    "8820": "W02",
  },
  "5500": {
    "9320": "W03",
    "9720": "W08",
  },
};
